export const SAVE_CALENDAR_VIEW_API_BASE_URL = 'ows/v1/SaveCalendarView';
export const MAX_SAVED_CALENDAR_VIEWS = 10;
